module.exports = __webpack_public_path__ + "media/images/product/pro_bg-9a5d31e7fdbd285abb857325f802eb2c.png";